"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _SourceListMediaItemBody = require("./SourceListMediaItemBody.styled");
var _ = require("../..");
var SourceListMediaItemBody = function SourceListMediaItemBody(_ref) {
  var type = _ref.type,
    hovered = _ref.hovered;
  var isAudioSource = type === _.AUDIO_FILE;
  return _react["default"].createElement(_SourceListMediaItemBody.Wrapper, {
    isAudioSource: isAudioSource,
    hovered: hovered
  }, _react["default"].createElement(_SourceListMediaItemBody.StyledIcon, {
    icon: _freeSolidSvgIcons.faPhotoVideo
  }));
};
SourceListMediaItemBody.propTypes = {
  onUploadClicked: _propTypes["default"].func.isRequired,
  type: _propTypes["default"].string.isRequired,
  hovered: _propTypes["default"].bool
};
var _default = exports["default"] = SourceListMediaItemBody;